var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    stroke: "none",
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.6802 9.75417C40.6587 8.73218 39.4459 7.92146 38.1109 7.36834C36.776 6.81521 35.3452 6.53052 33.9002 6.53052C32.4553 6.53052 31.0244 6.81521 29.6895 7.36834C28.3546 7.92146 27.1418 8.73218 26.1202 9.75417L24.0002 11.8742L21.8802 9.75417C19.8169 7.69078 17.0183 6.53159 14.1002 6.53159C11.1822 6.53159 8.38362 7.69078 6.32024 9.75417C4.25685 11.8176 3.09766 14.6161 3.09766 17.5342C3.09766 20.4522 4.25685 23.2508 6.32024 25.3142L8.44024 27.4342L24.0002 42.9942L39.5602 27.4342L41.6802 25.3142C42.7022 24.2927 43.5129 23.0798 44.0661 21.7449C44.6192 20.41 44.9039 18.9791 44.9039 17.5342C44.9039 16.0892 44.6192 14.6584 44.0661 13.3235C43.5129 11.9885 42.7022 10.7757 41.6802 9.75417V9.75417Z",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.0e0ee72f.svg";
export { ForwardRef as ReactComponent };